var _rect, _text, _text2, _rect2, _text3, _text4, _text5, _text6, _text7, _g, _g2, _g3, _g4, _circle, _g5, _g6, _g7, _circle2, _text8, _line, _text9, _text10, _text11, _text12, _text13, _text14, _rect3, _text15, _text16, _text17, _g8, _g9, _g10, _rect4, _text18, _line2, _polygon, _line3, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase3Fig2FanoutRestructured(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 640",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1200,
    height: 640,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The same job under two fan-out shapes")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "The measured cost of each, per-candidate fan-out on the left, one agent per book on the right.")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 96,
    width: 536,
    height: 390,
    rx: 12,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5,
    strokeDasharray: "6 4"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 126,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#DC2626"
  }, "PER-CANDIDATE FAN-OUT, THE FAILURE SHAPE")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 564,
    y: 126,
    fontSize: 10.5,
    fill: "#6B7F74",
    textAnchor: "end"
  }, "shown at reduced scale")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 164,
    fontSize: 11,
    fill: "#6B7F74"
  }, "per-book fan-out")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 266,
    fontSize: 11,
    fill: "#6B7F74"
  }, "per-candidate authoring")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 305,
    fontSize: 11,
    fill: "#6B7F74"
  }, "adversarial verify")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#D4DDD6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 385,
    y1: 168,
    x2: 238,
    y2: 203
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385,
    y1: 168,
    x2: 311,
    y2: 203
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385,
    y1: 168,
    x2: 385,
    y2: 203
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385,
    y1: 168,
    x2: 458,
    y2: 203
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385,
    y1: 168,
    x2: 532,
    y2: 203
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#D4DDD6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 238,
    y1: 216,
    x2: 210,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238,
    y1: 216,
    x2: 228.4,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238,
    y1: 216,
    x2: 246.8,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238,
    y1: 216,
    x2: 265.2,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311,
    y1: 216,
    x2: 283.6,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311,
    y1: 216,
    x2: 302,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311,
    y1: 216,
    x2: 320.4,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311,
    y1: 216,
    x2: 338.8,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385,
    y1: 216,
    x2: 357.2,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385,
    y1: 216,
    x2: 375.6,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385,
    y1: 216,
    x2: 394,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385,
    y1: 216,
    x2: 412.4,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458,
    y1: 216,
    x2: 430.8,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458,
    y1: 216,
    x2: 449.2,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458,
    y1: 216,
    x2: 467.6,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458,
    y1: 216,
    x2: 486,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: 532,
    y1: 216,
    x2: 504.4,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: 532,
    y1: 216,
    x2: 522.8,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: 532,
    y1: 216,
    x2: 541.2,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    x1: 532,
    y1: 216,
    x2: 559.6,
    y2: 258
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#D4DDD6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 266,
    x2: 210,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.4,
    y1: 266,
    x2: 228.4,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.8,
    y1: 266,
    x2: 246.8,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 265.2,
    y1: 266,
    x2: 265.2,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.6,
    y1: 266,
    x2: 283.6,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302,
    y1: 266,
    x2: 302,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320.4,
    y1: 266,
    x2: 320.4,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 338.8,
    y1: 266,
    x2: 338.8,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.2,
    y1: 266,
    x2: 357.2,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.6,
    y1: 266,
    x2: 375.6,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 394,
    y1: 266,
    x2: 394,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 412.4,
    y1: 266,
    x2: 412.4,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.8,
    y1: 266,
    x2: 430.8,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 449.2,
    y1: 266,
    x2: 449.2,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 467.6,
    y1: 266,
    x2: 467.6,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 486,
    y1: 266,
    x2: 486,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 504.4,
    y1: 266,
    x2: 504.4,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 522.8,
    y1: 266,
    x2: 522.8,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 541.2,
    y1: 266,
    x2: 541.2,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 559.6,
    y1: 266,
    x2: 559.6,
    y2: 298
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#D4DDD6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 305,
    x2: 385,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.4,
    y1: 305,
    x2: 385,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.8,
    y1: 305,
    x2: 385,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 265.2,
    y1: 305,
    x2: 385,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.6,
    y1: 305,
    x2: 385,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302,
    y1: 305,
    x2: 385,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320.4,
    y1: 305,
    x2: 385,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 338.8,
    y1: 305,
    x2: 385,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.2,
    y1: 305,
    x2: 385,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.6,
    y1: 305,
    x2: 385,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 394,
    y1: 305,
    x2: 385,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 412.4,
    y1: 305,
    x2: 385,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.8,
    y1: 305,
    x2: 385,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 449.2,
    y1: 305,
    x2: 385,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 467.6,
    y1: 305,
    x2: 385,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 486,
    y1: 305,
    x2: 385,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 504.4,
    y1: 305,
    x2: 385,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 522.8,
    y1: 305,
    x2: 385,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 541.2,
    y1: 305,
    x2: 385,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 559.6,
    y1: 305,
    x2: 385,
    y2: 352
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 385,
    cy: 160,
    r: 8,
    fill: "#1A2F2A"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#1A2F2A"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 210,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 210,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385,
    cy: 210,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 210,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 532,
    cy: 210,
    r: 5.5
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#1A2F2A"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 262,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.4,
    cy: 262,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.8,
    cy: 262,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.2,
    cy: 262,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.6,
    cy: 262,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302,
    cy: 262,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.4,
    cy: 262,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.8,
    cy: 262,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.2,
    cy: 262,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.6,
    cy: 262,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 262,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.4,
    cy: 262,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430.8,
    cy: 262,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.2,
    cy: 262,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.6,
    cy: 262,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486,
    cy: 262,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504.4,
    cy: 262,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522.8,
    cy: 262,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 541.2,
    cy: 262,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 559.6,
    cy: 262,
    r: 3.5
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#6B7F74"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.25,
    y: 298,
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.65,
    y: 298,
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.05,
    y: 298,
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.45,
    y: 298,
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.85,
    y: 298,
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.25,
    y: 298,
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.65,
    y: 298,
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.05,
    y: 298,
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.45,
    y: 298,
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.85,
    y: 298,
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.25,
    y: 298,
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.65,
    y: 298,
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.05,
    y: 298,
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.45,
    y: 298,
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.85,
    y: 298,
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.25,
    y: 298,
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.65,
    y: 298,
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520.05,
    y: 298,
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.45,
    y: 298,
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556.85,
    y: 298,
    width: 5.5,
    height: 5.5
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 385,
    cy: 362,
    r: 10,
    fill: "#DC2626"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 385,
    y: 390,
    fontSize: 12,
    fontWeight: 600,
    fill: "#DC2626",
    textAnchor: "middle"
  }, "single-agent dedup barrier")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 412,
    x2: 564,
    y2: 412,
    stroke: "#D4DDD6",
    strokeWidth: 1
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 446,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 30,
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "206")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 466,
    fontSize: 11.5,
    fill: "#6B7F74"
  }, "agents")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 446,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 30,
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "6.7M")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 466,
    fontSize: 11.5,
    fill: "#6B7F74"
  }, "tokens")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 438,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#DC2626"
  }, "usage cap reached")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 456,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#DC2626"
  }, "mid-run")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 616,
    y: 96,
    width: 536,
    height: 390,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 126,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "ONE AGENT PER BOOK, THE FIX")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 166,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "12 investigate-and-author agents, one per book")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 184,
    fontSize: 11,
    fill: "#6B7F74"
  }, "self-dedup runs inside each agent")), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#6B7F74",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M654 202 C650 191, 670 191, 666 202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696 202 C692 191, 712 191, 708 202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738 202 C734 191, 754 191, 750 202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780 202 C776 191, 796 191, 792 202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822 202 C818 191, 838 191, 834 202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864 202 C860 191, 880 191, 876 202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906 202 C902 191, 922 191, 918 202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948 202 C944 191, 964 191, 960 202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990 202 C986 191, 1006 191, 1002 202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032 202 C1028 191, 1048 191, 1044 202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074 202 C1070 191, 1090 191, 1086 202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116 202 C1112 191, 1132 191, 1128 202"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    stroke: "#D4DDD6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 228,
    x2: 806,
    y2: 326
  }), /*#__PURE__*/React.createElement("line", {
    x1: 702,
    y1: 228,
    x2: 821.5,
    y2: 326
  }), /*#__PURE__*/React.createElement("line", {
    x1: 744,
    y1: 228,
    x2: 836.9,
    y2: 326
  }), /*#__PURE__*/React.createElement("line", {
    x1: 786,
    y1: 228,
    x2: 852.4,
    y2: 326
  }), /*#__PURE__*/React.createElement("line", {
    x1: 828,
    y1: 228,
    x2: 867.8,
    y2: 326
  }), /*#__PURE__*/React.createElement("line", {
    x1: 870,
    y1: 228,
    x2: 883.3,
    y2: 326
  }), /*#__PURE__*/React.createElement("line", {
    x1: 912,
    y1: 228,
    x2: 898.7,
    y2: 326
  }), /*#__PURE__*/React.createElement("line", {
    x1: 954,
    y1: 228,
    x2: 914.2,
    y2: 326
  }), /*#__PURE__*/React.createElement("line", {
    x1: 996,
    y1: 228,
    x2: 929.6,
    y2: 326
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1038,
    y1: 228,
    x2: 945.1,
    y2: 326
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 228,
    x2: 960.5,
    y2: 326
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1122,
    y1: 228,
    x2: 976,
    y2: 326
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    stroke: "#1A2F2A",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 647,
    y: 202,
    width: 26,
    height: 26,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 689,
    y: 202,
    width: 26,
    height: 26,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 731,
    y: 202,
    width: 26,
    height: 26,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 202,
    width: 26,
    height: 26,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 815,
    y: 202,
    width: 26,
    height: 26,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 857,
    y: 202,
    width: 26,
    height: 26,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 202,
    width: 26,
    height: 26,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 941,
    y: 202,
    width: 26,
    height: 26,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 983,
    y: 202,
    width: 26,
    height: 26,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1025,
    y: 202,
    width: 26,
    height: 26,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1067,
    y: 202,
    width: 26,
    height: 26,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1109,
    y: 202,
    width: 26,
    height: 26,
    rx: 6
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 796,
    y: 326,
    width: 190,
    height: 44,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 891,
    y: 353,
    fontSize: 13,
    fontWeight: 600,
    fill: "#16A34A",
    textAnchor: "middle"
  }, "JavaScript union merge")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 891,
    y1: 370,
    x2: 891,
    y2: 398,
    stroke: "#16A34A",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "886,396 891,404 896,396",
    fill: "#16A34A"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 412,
    x2: 1132,
    y2: 412,
    stroke: "#D4DDD6",
    strokeWidth: 1
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 446,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 30,
    fontWeight: 700,
    fill: "#16A34A"
  }, "12")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 466,
    fontSize: 11.5,
    fill: "#6B7F74"
  }, "agents")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 730,
    y: 446,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 30,
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "851K")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 730,
    y: 466,
    fontSize: 11.5,
    fill: "#6B7F74"
  }, "tokens")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 860,
    y: 446,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 30,
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "6 min")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 860,
    y: 466,
    fontSize: 11.5,
    fill: "#6B7F74"
  }, "approx. run time")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 990,
    y: 446,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 30,
    fontWeight: 700,
    fill: "#16A34A"
  }, "124")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 990,
    y: 466,
    fontSize: 11.5,
    fill: "#6B7F74"
  }, "net-new designs")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 600,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 14,
    fontWeight: 600,
    fill: "#16A34A"
  }, "17x fewer agents, 8x fewer tokens, close to 40x more design output per token")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase3Fig2FanoutRestructured);
export default __webpack_public_path__ + "static/media/case3-fig2-fanout-restructured.2e8b1d2813b8ed8b710f9d92586a2453.svg";
export { ForwardRef as ReactComponent };